import { ConfirmDialog } from '@roc/ui';
import { useDrawsStore } from '@roc/feature-draws';
import { observer } from 'mobx-react';

export const ApproveSOW = observer(({ loanId, drawId, afterActionExecuted }) => {

  const { drawStore: { drawActionsStore } } = useDrawsStore();

  const confirmHandler = () => {
    drawActionsStore.approveSOWs(drawId, afterActionExecuted);
  }

  return (
    <ConfirmDialog
      open={drawActionsStore.isApproveSOWsDialogOpen}
      confirmButtonText='Confirm'
      handleClose={() => drawActionsStore.setIsApproveSOWsDialogOpen(false)}
      handleCancel={() => drawActionsStore.setIsApproveSOWsDialogOpen(false)}
      handleConfirm={confirmHandler}
      title={'Approve SOW(s)'}
      body={`Are you sure you want to approve the SOW(s) associated with the draw?`}
    />
  );
});
